export default "__VITE_ASSET__VN33UC5s__"